export default "__VITE_ASSET__160017ac__"